export default __webpack_public_path__ + "static/media/features2.2b154866.svg";